import { g as r } from "./get-built-in.js";
import { h as o } from "./has-own-property.js";
import { c as t } from "./create-non-enumerable-property.js";
import { o as s } from "./object-is-prototype-of.js";
import { o as e } from "./object-set-prototype-of.js";
import { c as a } from "./copy-constructor-properties.js";
import { p as i } from "./proxy-accessor.js";
import { i as p } from "./inherit-if-required.js";
import { n as m } from "./normalize-string-argument.js";
import { i as n } from "./install-error-cause.js";
import { e as c } from "./error-stack-install.js";
import { d as f } from "./descriptors.js";
var u = function u(_u, j, l, h) {
  var y = "stackTraceLimit",
    g = h ? 2 : 1,
    v = _u.split("."),
    d = v[v.length - 1],
    w = r.apply(null, v);
  if (w) {
    var b = w.prototype;
    if (o(b, "cause") && delete b.cause, !l) return w;
    var k = r("Error"),
      E = j(function (r, o) {
        var e = m(h ? o : r, void 0),
          a = h ? new w(r) : new w();
        return void 0 !== e && t(a, "message", e), c(a, E, a.stack, 2), this && s(b, this) && p(a, this, E), arguments.length > g && n(a, arguments[g]), a;
      });
    E.prototype = b, "Error" !== d ? e ? e(E, k) : a(E, k, {
      name: !0
    }) : f && y in w && (i(E, w, y), i(E, w, "prepareStackTrace")), a(E, w);
    try {
      b.name !== d && t(b, "name", d), b.constructor = E;
    } catch (r) {}
    return E;
  }
};
export { u as w };